module.exports = __webpack_public_path__ + "ca5c8ab3217fa7a31c6e075a3dd023db.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/onboarding-who-read.png
// module id = 1119
// module chunks = 0